module.exports = __webpack_public_path__ + "static/quiet-08847799d4a8f4bf2ee9669c0c6694bb.jpg";